<template>
  <div
    :class="{
      'tw:self-end tw:ml-20': message.type === 'user',
      'tw:self-start tw:mr-20': message.type === 'agent',
    }"
    class="tw:w-fit tw:max-w-[80%]"
  >
    <div
      :class="{
        'tw:bg-black': message.type === 'user',
        'tw:bg-default-100': message.type === 'agent',
      }"
      class="tw:p-4 tw:relative tw:rounded-2xl"
    >
      <!-- Loading State -->
      <div v-if="message.isLoading" class="tw:flex tw:items-center tw:gap-3">
        <div class="tw:flex tw:gap-1">
          <div class="typing-dot"></div>
          <div class="typing-dot" style="animation-delay: 0.2s"></div>
          <div class="typing-dot" style="animation-delay: 0.4s"></div>
        </div>
        <p class="tw:text-default-700">
          {{ message.content }}
        </p>
      </div>

      <!-- Regular Message -->
      <div v-else>
        <!-- User attachment image (if present) -->
        <div v-if="message.type === 'user' && message.imageUrl" class="tw:mb-3">
          <img
            :alt="trans.download.alt_attached"
            :src="message.imageUrl"
            class="tw:max-h-32 tw:rounded-lg tw:border tw:border-white/20"
          />
        </div>

        <p
          :class="{
            'tw:text-white': message.type === 'user',
            'tw:text-black': message.type === 'agent',
          }"
        >
          {{ message.content }}
        </p>

        <!-- Generated Image -->
        <div v-if="message.imageUrl" class="tw:mt-4">
          <img
            :alt="trans.download.alt_generated"
            :src="message.imageUrl"
            class="tw:w-full tw:h-auto tw:rounded-lg tw:border tw:border-default-200"
          />

          <!-- Download button only -->
          <div class="tw:flex tw:justify-end">
            <EdroneButtonIcon :title="trans.download.title" type="plain" @click="handleDownload">
              <FontAwesomeIcon icon="fa-light fa-download" />
            </EdroneButtonIcon>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import EdroneButtonIcon from "edrone-components/EdroneButtonIcon.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

type ChatMessage = {
  type: "user" | "agent";
  content: string;
  imageUrl?: string;
  isLoading?: boolean;
};

interface Props {
  message: ChatMessage;
}

interface Emits {
  (e: "download", imageUrl: string): void;
}

const props = defineProps<Props>();
const _emit = defineEmits<Emits>();

const trans = window._trans._branding.aiBanner;

const handleDownload = () => {
  if (props.message.imageUrl) {
    const link = document.createElement("a");
    link.href = "/ai-banner/download?url=" + props.message.imageUrl;
    link.download = `banner-${Date.now()}.png`;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};
</script>

<style scoped>
.typing-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #6b7280;
  animation: typing 1.4s infinite ease-in-out;
}

@keyframes typing {
  0%,
  80%,
  100% {
    transform: scale(0);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
